import { HashRouter, Route, Routes } from "react-router-dom";
import { PageContainer } from "./components/PageContainer";
import { DashboardPage } from "./pages/DashboardPage";
import { LoginPage } from "./pages/LoginPage";
import { InspectionPage } from "./pages/InspectionPage";
import { InspectionListingPage } from "./pages/InspectionListingPage";
import { useEffect, useState } from "react";
import { WindowSettingsContext, ProfileContext } from "./components/ProfileContext";
import { DebugPage } from "./pages/DebugPage";
import { JobListingPage } from "./pages/JobListingPage";
import { JobEditPage } from "./pages/JobEditPage";
import { InspectionSearchPage } from "./pages/InspectionSearchPage";
import { SurveyPage } from "./pages/SurveyPage";
import { SurveyListPage } from "./pages/SurveyListPage";
import { ComponentTypePage } from "./pages/ComponentTypePage";
import { ComponentTypeListPage } from "./pages/ComponentTypeListPage";
import { AdminDashboardPage } from "./pages/AdminDashboardPage";
import { AssetPage } from "./pages/AssetPage";
import { AssetListingPage } from "./pages/AssetListingPage";
import { Survey } from "./models/Survey";
import { Job } from "./models/Job";
import { User } from "./models/User";
import { ComponentType } from "./models/ComponentType";
import { SettingsPage } from "./pages/SettingsPage";
import { JobPage } from "./pages/JobPage";
import { InspectionBeginPage } from "./pages/InspectionBeginPage";
import { PartsListingPage } from "./pages/PartsListingPage";
import { useInitialUpdatableContext } from "./components/UpdatableContext";
import { SharedInspectionPage } from "./pages/SharedInspectionPage";

export function App(props) {
	let [prevProfile, setPrevProfile] = useState(null);
	let [profile, setProfile, profileCtx, profileReady] = useInitialUpdatableContext();
	let [displaySettings, setDisplaySettings, displaySettingsCtx, displaySettingsReady] = useInitialUpdatableContext({context:"APP"});

	let contextsReady = profileReady && displaySettingsReady;

	useEffect(() => {
		// On load, check for session storage with the display context
		let displayContext = window.sessionStorage.getItem("displayContext");
		if(!!displayContext) {
			if(displayContext != displaySettings.context) { // Be sure not to run in a loop
				displaySettings.context = displayContext;
				setDisplaySettings(displaySettings);	
			}
		}
	});

	if(contextsReady) {
		if(profile == null) {
			if(prevProfile?.userName != null) {
				setPrevProfile(null);
			}
			User.loadCurrentUser().then(u => {
				if(u != null) {
					setProfile(u);
				}
			})
		} else {
			if(prevProfile?.userName != profile.userName) {
				setPrevProfile(profile);
				Survey.syncSurveys(profile);
				Job.syncJobs(profile);
				ComponentType.syncComponentTypes(profile);	
			}
		}
	}

	return (
		<ProfileContext.Provider value={profileCtx}>
			<WindowSettingsContext.Provider value={displaySettingsCtx}>
				<HashRouter>
					<PageContainer>
						<Routes>
							{/* public routes */}
							<Route path="inspections/search" element={<InspectionSearchPage />} />
							<Route path="inspections/search/:externalIdentifier" element={<InspectionSearchPage />} />
							<Route path="inspections/shared/:inspectionId/:sharingCode" element={<SharedInspectionPage />} />
							{(profile == null && (contextsReady)) && <Route path="*" element={<LoginPage />} />}

							{/* Logged in routes */}
							{profile != null && <>
								<Route path="/" element={<DashboardPage />} />
								<Route path="debug" element={<DebugPage />} />
								<Route path="jobs/new" element={<JobEditPage />} />
								<Route path="jobs" element={<JobListingPage />} />
								<Route path="jobs/:jobId" element={<JobPage />} />
								<Route path="jobs/:jobId/edit" element={<JobEditPage />} />
								<Route path="parts" element={<PartsListingPage />} />
								<Route path="dashboard" element={<DashboardPage />} />
								<Route path="login" element={<LoginPage />} />
								<Route path="assets" element={<AssetListingPage />} />
								<Route path="assets/search" element={<AssetPage />} />
								<Route path="assets/:assetNumber" element={<AssetPage />} />
								<Route path="inspections/new"  element={<InspectionPage />} />
								<Route path="inspections/begin" element={<InspectionBeginPage />} />
								<Route path="inspections" element={<InspectionListingPage />} />
								<Route path="inspections/:inspectionId" element={<InspectionPage />} />
								<Route path="settings" element={<SettingsPage />} />

								{/* Semi-Admin Routes */}
								<Route path="admin" element={<AdminDashboardPage />} />
								<Route path="surveys" element={<SurveyListPage />} />
								<Route path="surveys/:surveyId" element={<SurveyPage />} />
								
								{/* Admin routes */}
								{profile.admin && <>
									<Route path="componentTypes" element={<ComponentTypeListPage />} />
									<Route path="componentTypes/:componentTypeId" element={<ComponentTypePage />} />
								</>}

								<Route path="*" element={<div>wrongpage</div>} />							
							</>}
						</Routes>
					</PageContainer>
				</HashRouter>
			</WindowSettingsContext.Provider>
		</ProfileContext.Provider>
	);

}
